import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_active_sources = async () => {
  const requestObj = {
    path: `api/source/get_active_source`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_active_source_features = async (data) => {
  const requestObj = {
    path: `api/feature/get_features_for_sources`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const api_call_with_path_get = async (path) => {
  const requestObj = {
    path: path,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};


export const report_job_or_post = async (data) => {
  const requestObj = {
    path: `api/report/add_report`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
